import { render } from "./FormBuilder.vue?vue&type=template&id=20689a23&ts=true"
import script from "./FormBuilder.vue?vue&type=script&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/FormBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20689a23"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20689a23', __exports__)) {
    api.reload('20689a23', __exports__)
  }
  
  module.hot.accept("./FormBuilder.vue?vue&type=template&id=20689a23&ts=true", () => {
    api.rerender('20689a23', render)
  })

}


export default __exports__